import { useQuery } from "react-query";
import { CollectionResponse, getItemContent } from "@/api/content.ts";
import { filterUnsupportedItems } from "@/utils";

export const useCollection = (tabId: number) => {
  return useQuery<CollectionResponse>(
    ["collection", tabId],
    () => {
      return getItemContent(tabId, "collection").then((data) => {
        return { ...data, Items: filterUnsupportedItems(data.Items) };
      });
    },
    {
      enabled: tabId > 0,
    },
  );
};
